import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { ColumnContent, ColumnContentLarge, ColumnContentLargeTitle, ColumnContentSmall, ColumnContentSmallTitle } from 'styles/ColumnContent';
import { ContentList, Text } from 'styles/Layout';
import { Container } from 'styles';
import LayoutContext from 'context/layout';
import Breadcrumb from 'components/layout/breadcrumb/Breadcrumb';
import SectionItem from 'components/layout/section-item/SectionItem';
import ReturnButton from 'components/layout/return-button/ReturnButton';
import CategoryHelpBlock from 'components/category/category-help-block/CategoryHelpBlock';
import FaqService from 'services/faqService';
import { getCategoryLabel } from 'utils/appUtils';
import Loading from 'components/layout/loading/Loading';

const LoadMoreButton = styled.button`
    background: #F0F0F0;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    font-size: 1.125rem;
    height: 3.5rem;
    margin-bottom: 2rem;
    width: 100%;

    &:disabled {
        cursor: default;
        opacity: 0.6;
    }
`;

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const CategoryPage = () => {
    let query = useQuery();
    const navigate = useNavigate();
    const { setState } = useContext(LayoutContext);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [sections, setSections] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
		setState({ displaySearch: true, isHome: false });
        validateQuery();
	}, []);

    const validateQuery = () => {
        const type = query.get('type');

        if (type) {
            getSections(0);
            return;
        }
        navigate('/');
    }

    const getSections = (pageToLoad) => {
        const payload = { categoryType: query.get('type').toUpperCase() };
        FaqService.getSections({ page: pageToLoad }, payload)
            .then(({ data }) => {
                setSections(current => pageToLoad === 0 ? data.content : [...current, ...data.content]);
                setPage(data.number);
                setTotalPages(data.totalPages);
            })
            .catch(() => navigate('/'))
            .finally(() => {
                setIsLoading(false);
                setIsLoadingMore(false);
            })
    }

    const loadMoreSections = () => {
        setIsLoadingMore(true);
        getSections(page + 1);
    }

    const hasMoreSections = page + 1 < totalPages;

	return (
        <>
            {isLoading ? (<Loading height="300px" />) : (
                <>
                    <Breadcrumb currentPageName={getCategoryLabel(query.get('type'))} />

                    <Container>
                        <ColumnContent>
                            <ColumnContentSmall mobileHidden>
                                <ColumnContentSmallTitle>Vamos de ajudar!</ColumnContentSmallTitle>
                                <CategoryHelpBlock text="Confira os artigos que podem te ajudar com as dúvidas mais comuns ou selecione uma sessão para ver mais artigos relacionados. Se ainda precisar de ajuda nos envie sua dúvida ou solicitação." />

                            </ColumnContentSmall>

                            <ColumnContentLarge>
                                <ColumnContentLargeTitle>{getCategoryLabel(query.get('type'))}</ColumnContentLargeTitle>

                                <ContentList>
                                    {sections.map(section => <SectionItem key={section.id} id={section.id} name={section.name} type={section.categoryType} />)}
                                </ContentList>

                                {hasMoreSections && (
                                    <LoadMoreButton onClick={loadMoreSections} disabled={isLoadingMore}>
                                        {isLoadingMore ? 'Carregando...' : 'Carregar mais'}
                                    </LoadMoreButton>
                                )}

                                <CategoryHelpBlock desktopHidden text="Confira os artigos que podem te ajudar com as dúvidas mais comuns ou selecione uma sessão para ver mais artigos relacionados. Se ainda precisar de ajuda nos envie sua dúvida ou solicitação." />

                                <ReturnButton />
                            </ColumnContentLarge>
                        </ColumnContent>
                    </Container>
                </>
            )}
        </>
	);
};

export default CategoryPage;